import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AddressConfig } from 'src/app/shared/components/address/address-config.model';
import { AddressComponent } from 'src/app/shared/components/address/address.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { DataService } from 'src/app/shared/services/data.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { CustomValidator } from 'src/app/shared/validators/custom-validator';
import { ConfirmDailogueComponent } from '../../../../shared/components/dailogue/confirm-dailogue.component';

@Component({
    selector: 'app-bank-form',
    templateUrl: './bank-form.component.html',
    styleUrls: ['./bank-form.component.less'],
    standalone: false
})
export class BankFormComponent implements OnInit {
  bankForm:FormGroup;
  id:number;
  companyId:number;
  countryId:number;
  isEditedData:boolean=false;
  @ViewChild(AddressComponent) addressComponent;
  accountTypes:any;
  constructor(private formBuilder:FormBuilder,
             private logger:NGXLogger,private dailog:MatDialog,
            private router:Router,private activatedRoute:ActivatedRoute,
            private utilityService:UtilityService,private service:DataService) { }
  addressConfig=new AddressConfig(false,false,true,false,true,false,false,false,true);

  ngOnInit(): void 
  {
    this.companyId=+localStorage.getItem('COMPANY_ID');
    this.getCompanyById();
    this.logger.info('CompanyId '+this.companyId);
    this.initializeForm();
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        this.id=+param['id'];
        if(this.id)
          this.getBankById(this.id);
      });
    this.getAllAccountTypes();
  }

  getCompanyById()
  {
    if(this.companyId) {
      this.service.get(Api.COMPANY+'/'+this.companyId).subscribe(data => {
        this.logger.info('company details by id', data);
        this.countryId=data.address.countryId;
        this.logger.info('Country Id', this.countryId);
      });
    }
  }

  getBankById(id?:number){
     if(!id){
       return;
     }
     if(this.id){
      this.service.get(Api.BANK+'/'+this.id).subscribe(data => {
        this.logger.info('Bank details by id', data);
        if(data){
          this.logger.info("THISS IS INSIDE  ");
          // this.bankForm.patchValue(data);
          this.addressComponent.address.patchValue({...data.address,
            landMarkSet:data.address?.landMarkSet || []    
          });
          this.bankForm.patchValue({...data,
            address: {...data.address,
              landMarkSet:data.address?.landMarkSet || []    
            }
          });
          // this.addressComponent.address.patchValue(data.address);
        }
      });
    }
  }

  initializeForm(){
    this.bankForm=this.formBuilder.group({
      id:[null],
      code:[null,[Validators.required]],
      name:['',[Validators.required,CustomValidator.whiteSpaceValidator]],
      branchName:[null,[Validators.required]],
      ifscCode:[null],
      accountNo:[null,[Validators.required,Validators.pattern("^[0-9]+$")]],
      accountType:[null,[Validators.required]],
      swiftCode:[],
      address:this.utilityService.getAddressForm(),
      relationshipManager:[],
      emailId:['',[Validators.email]],
      contactNo:[null,Validators.pattern('^[0-9]+$')],
      viewLog: []
    })
  }

  getAllAccountTypes(){
    this.service.get(Api.ACCOUNT_TYPE_LIST).subscribe(res => {
        this.logger.info('Account list res ', res)
        this.accountTypes = res;
    }); 
  }

  openDialog(message?:string){
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
      // data:'Bank',
      data:message,
      maxWidth:"300px",
      maxHeight:"150px"
    });

    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else{
          if(!this.isEditedData){
            this.saveBank();
          }
          else{
            this.saveBank();
          }
        }
    })
  }


  saveBank(){
    let method = (this.id) ? 'put' : 'post';
    let message=(this.id)?'updated':'saved';
    this.service[method](Api.BANK, this.bankForm.value).subscribe(bankIdValue => {
      this.logger.info('Bank save success ', bankIdValue);
      this.utilityService.notifier('Bank Details '+message+' successfully', 'success');
      this.navigateToBankList();
    });
  }
  
  onSave(){
    this.address=this.addressComponent?.address?.value;
    this.addressComponent.address.markAllAsTouched();
    this.bankForm.markAllAsTouched();
     if(this.bankForm.valid && this.addressComponent.address.valid && this.id){
         this.isEditedData=true;
         this.openDialog(Message.SAVE_OPEN_DAILOG_IN_EDIT);    
     } 
     else if(this.bankForm.valid && this.addressComponent.address.valid){
      this.openDialog(Message.SAVE_OPEN_DAILOG);
     }   
  }

  onCancel(){
    if(this.bankForm.dirty){
       this.openDialog(Message.CANCEL_OPEN_DAILOG_IN_EDIT);
    }
    else{
      this.navigateToBankList();
    }
  }

  navigateToBankList(){
    this.router.navigate([APP_ROUTES.BANK_LIST]);
  }


  set address(address){ this.bankForm?.get('address')?.patchValue(address); }
  get accountType(){ return this.bankForm.get('accountType')};
  get emailId(){return this.bankForm.get('emailId')};
  get accountNo(){return this.bankForm.get('accountNo')};
  get branchName(){return this.bankForm.get('branchName')};
  get bankCode(){return this.bankForm.get('code')};
  get bankName(){return this.bankForm.get('name')};
  get contactNo(){return this.bankForm.get('contactNo')};
  get viewLog() { return this.bankForm.get('viewLog'); };
  get address(){return this.bankForm.get('address')};
}
